"use client";

import { useQuery } from '@tanstack/react-query'
import { getApi } from "@src/config/apiWithAxios"
import { URL_PROPERTY_CATEGORIES } from "@src/constant/api-url"
import { KEY_PROPERTY_CATEGORIES } from "@src/constant/query-keys/global"

const getPropertyCategories = async ({ queryKey }) => {
  const [_key, { requestUrl, params }] = queryKey;
  const res = await getApi(requestUrl, params);

  return res?.data?.data
}

export const useQueryPropertyCategories = () => {
  const dependencies = {
    requestUrl: URL_PROPERTY_CATEGORIES,
    params: {
      _limit: 30
    }
  }
  
  return useQuery({
    queryKey: [KEY_PROPERTY_CATEGORIES, dependencies],
    queryFn: getPropertyCategories
  })
}
